import React, { useState } from 'react';
import { Modal } from 'react-responsive-modal';
import { Button } from 'reactstrap';

const AddContract = ({ open, onClose }) => {
  const [isChecked, setIsChecked] = useState(false);

  const handleCheckboxChange = () => {
    setIsChecked(!isChecked);
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
      showCloseIcon={false}
      classNames={{ modal: 'custom-modal2' }}
    >
      <div className="d-flex justify-content-between align-items-center">
        <h5>Create Contract</h5>
        <i
          onClick={onClose}
          className="fa fa-times font-20"
          style={{ cursor: 'pointer' }}
        ></i>
      </div>
      <div>
        <div className="d-flex justify-content-between" style={{ gap: '30px' }}>
          <div>
            <label>Members</label>
            <div
              className="d-flex border rounded p-3"
              style={{ gap: '20px', width: '400px' }}
            >
              <select className="form-control" style={{ width: '170px' }}>
                <option>Select Members</option>
                <option value="true">Member Rate</option>
                <option value="false">Project Rate</option>
              </select>
              <select className="form-control" style={{ width: '170px' }}>
                <option>Select Teams</option>
                <option value="true">Member Rate</option>
                <option value="false">Project Rate</option>
              </select>
            </div>
          </div>
          <div>
            <label>Projects</label>
            <div
              className="d-flex align-items-center border rounded p-3"
              style={{ gap: '20px', width: '300px' }}
            >
              <select className="form-control" style={{ width: '250px' }}>
                <option>Select Projects</option>
                <option value="true">Member Rate</option>
                <option value="false">Project Rate</option>
              </select>
            </div>
          </div>
        </div>
        <div className="mt-4">
          <label>Contract details</label>
          <div className="d-flex flex-column border rounded p-3">
            <label
              className="d-flex align-items-center text-muted ml-1 mt-2"
              style={{ cursor: 'pointer', fontWeight: '100' }}
            >
              <input
                type="checkbox"
                checked={isChecked}
                onChange={handleCheckboxChange}
                className="mr-3 checkbox_2"
              />
              Assign to all tasks
            </label>
            <div
              className="d-flex justify-content-between align-items-center mt-2"
              style={{ gap: '10px' }}
            >
              <div className="form-group">
                <label className="text-muted" style={{ fontWeight: '100' }}>
                  Rate Type
                </label>
                <div className="">
                  <select className="form-control">
                    <option>Custom Rate</option>
                    <option value="true">Member Rate</option>
                    <option value="false">Project Rate</option>
                  </select>
                </div>
              </div>

              <div className="form-group ">
                <label
                  for="username "
                  className="font-14 text-muted "
                  style={{ fontWeight: '100' }}
                >
                  Hourly rate (USD)
                </label>
                <input
                  type="number"
                  className="form-control"
                  id="username"
                  style={{ width: '150px' }}
                />
              </div>

              <div className="form-group">
                <label
                  for="username3 "
                  className="font-14 text-muted"
                  style={{ fontWeight: '100' }}
                >
                  Weekly limit (hrs)
                </label>
                <input
                  type="number"
                  className="form-control"
                  id="username3"
                  style={{ width: '150px' }}
                />
              </div>

              <div className="form-group">
                <label className="text-muted" style={{ fontWeight: '100' }}>
                  Screenshot mode
                </label>
                <div className="">
                  <select className="form-control">
                    <option value="true">Default (Screenshot)</option>
                    <option value="false">No Screenshot</option>
                    <option value="fa">Blur Screenshot</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="modal-footer mt-4">
        <button type="button" className="btn btn-light" onClick={onClose}>
          Cancel
        </button>
        <button type="button" className="btn btn-purple">
          Create Project
        </button>
      </div>
    </Modal>
  );
};

export default AddContract;
